var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8382 15.6316V12C15.8382 10.3431 14.495 9 12.8382 9H6V5.52632C6 4.13107 7.13107 3 8.52632 3H20.3158C21.711 3 22.8421 4.13107 22.8421 5.52632V13.1053L22.8588 17.7868C22.8598 18.0629 22.6367 18.2876 22.3606 18.2886C22.2273 18.289 22.0994 18.2363 22.0052 18.1421L19.4947 15.6316H15.8382Z",
    fill: "#B0B7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98511 18V13C1.98511 11.8954 2.88054 11 3.98511 11H11.9851C13.0897 11 13.9851 11.8954 13.9851 13V18C13.9851 19.1046 13.0897 20 11.9851 20H4.10084L2.85699 21.1905C2.65749 21.3815 2.34099 21.3745 2.15005 21.175C2.06098 21.082 2.01126 20.9581 2.01126 20.8293V18.3243C1.99405 18.2187 1.98511 18.1104 1.98511 18ZM6.50005 14C6.22391 14 6.00005 14.2239 6.00005 14.5C6.00005 14.7761 6.22391 15 6.50005 15H11.5001C11.7762 15 12.0001 14.7761 12.0001 14.5C12.0001 14.2239 11.7762 14 11.5001 14H6.50005ZM9.50005 16C9.22391 16 9.00005 16.2239 9.00005 16.5C9.00005 16.7761 9.22391 17 9.50005 17H11.5001C11.7762 17 12.0001 16.7761 12.0001 16.5C12.0001 16.2239 11.7762 16 11.5001 16H9.50005Z",
    fill: "#B0B7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupChat);
export default __webpack_public_path__ + "static/media/group-chat.be59440e5619bbd38a269629e15fd28e.svg";
export { ForwardRef as ReactComponent };